import { render } from "./DeleteConfirmationModal.vue?vue&type=template&id=345ca131&scoped=true"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"

import "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=345ca131&scoped=true&lang=css"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345ca131"]])

export default __exports__